import React, { useCallback, useState, useEffect, useRef, useMemo } from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Calendar as CalendarIcon, Clock, Hourglass, Bell } from "lucide-react";
import CloseIcon from "@mui/icons-material/Close";
import { ChevronDown, Users } from "lucide-react";
import {
    setInit,
    setTitle,
    setShowUserList,
    setDescription,
    setFilteredUsers,
    setIsDropdownHovered,
    setShowRoomDropdown,
    setInvites,
    NEW_RESERVATION,
    UPDATE_RESERVATION,
    DELETE_RESERVATION,
    setRooms,
    setNonGuestUsers,
    setOpen,
    setShowMonthList,
    setShowYearList,
    setShowDescription,
    setIsEditingTime,
    setSelectedRoomupdate,
    setTime,
    setReminder,
    setDuration,
    setInviteInput,
    setConfirmDialogOpen
} from '../../store/AddEvent/AddEventSlice.js';
import "./AddEvent.css";
import { useSelector, useDispatch } from "react-redux";
import {
    updateBooking,
    deleteBooking,
    createBooking,
    fetchUsersNotGuest,
    fetchRoomsByMapId,
    fetchNonGuestUsersByMap
} from "../../store/AddEvent/AddEventThunks";
import { getAllUsers } from '../../store/userManagement/userManagementThunks.js';
import { fetchReservations } from "../../store/myEventModal/myEventModalThunks";
import {
    setAnchorPosition,
} from '../../../Map/store/MapDisplaySlice';
import { setOpenModal } from "../../../../features/ControlPanel/store/controlPanelSlice.js";
import ActionConfirmation from "../../../../components/ActionConfirmation";
import { useTranslation } from "react-i18next";
import { getLocaleObject } from '../../../../utils/localeUtils.js';
import CustomRecurrencePopup from "./CustomRecurrencePopup/CustomRecurrencePopup";
import CustomDropdown from "./Dropdown/CustomDropdown";

export default function AddEvent({ onClose }) {

    const {
        localAvatar
    } = useSelector((state) => state.auth);

    const [successMessage, setSuccessMessage] = useState(null);

    const timeInputRef = useRef(null);
    const dropdownRef = useRef(null);
    const timeOptionsRef = useRef(null);
    const initRef = useRef(false);
    const [date, setDate] = useState(new Date());
    const [pickingFromList, setPickingFromList] = useState(false);
const [showDurationDropdown, setShowDurationDropdown] = useState(false);
const [showReminderDropdown, setShowReminderDropdown] = useState(false);
    const { t } = useTranslation();

    const {
        title,
        invites,
        description,
        filteredUsers,
        isDropdownHovered,
        showRoomDropdown,
        showUserList,
        rooms,
        nonGuestUsers,
        open,
        showMonthList,
        showYearList,
        showDescription,
        isEditingTime,
        selectedRoomUpdate,
        time,
        duration,
        reminder,
        inviteInput,
        confirmDialogOpen
    } = useSelector((state) => state.AddEvent);

    const { preferredLanguage } = useSelector((state) => state.auth);

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 50 }, (_, i) => currentYear + i);
    const MONTHS = useMemo(() => {
        const months = [];
        for (let i = 0; i < 12; i++) {
            const date = new Date(2023, i, 1);
            months.push(date.toLocaleDateString(preferredLanguage, { month: 'long' }));
        }
        return months;
    }, [preferredLanguage]);
    const {
        initialReservation,
        updateRoom
    } = useSelector((state) => state.RoomMenu);
    const dispatch = useDispatch();
    const {
        selectedRoom,
        roomsData,
        mapConfig
    } = useSelector((state) => state.MapDisplay);
    const {
        tenant
    } = useSelector((state) => state.auth);
    const tenantId = tenant?.id;
    const email = localAvatar?.email;
    const [error, setError] = useState();
    const [recurrenceType, setRecurrenceType] = useState("none");
    const [showCustomRecurrence, setShowCustomRecurrence] = useState(false);
    const [recurrenceConfig, setRecurrenceConfig] = useState({
        recurrence_unit: null,
        recurrence_frequency: 1,
        recurrence_days: [],
        recurrence_end_type: "never",
        recurrence_end_date: null,
        recurrence_occurrences: null,
    });
    const [recurrenceSummary, setRecurrenceSummary] = useState("");
    const getDayCode = (date) => {
        const dayIndex = new Date(date).getDay();
        return ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"][dayIndex];
    };

    const handleRecurrenceChange = (value) => {
        if (value === "custom") {
            setShowCustomRecurrence(true);
            setRecurrenceType("custom");
            return;
        }
        setRecurrenceType(value);

        let recurrenceConfig = null;

        if (value === "daily") {
            recurrenceConfig = {
                recurrence_unit: "day",
                recurrence_frequency: 1,
                recurrence_days: [],
                recurrence_end_type: "never",
            };
        } else if (value === "weekly") {
            recurrenceConfig = {
                recurrence_unit: "week",
                recurrence_frequency: 1,
                recurrence_days: [getDayCode(date)],
                recurrence_end_type: "never",
            };
        } else if (value === "yearly") {
            recurrenceConfig = {
                recurrence_unit: "year",
                recurrence_frequency: 1,
                recurrence_days: [],
                recurrence_end_type: "never",
            };
        }
        else if (value === "none") {
            setRecurrenceConfig({
                recurrence_unit: null,
                recurrence_frequency: 1,
                recurrence_days: [],
                recurrence_end_type: "never",
                recurrence_end_date: null,
                recurrence_occurrences: null,
            });
            setRecurrenceType("none");
            setRecurrenceSummary("");
            return;
        }
        setRecurrenceConfig(recurrenceConfig);
    };
const closeAllDropdowns = (except) => {
    if (except !== 'date') dispatch(setOpen(false));
    if (except !== 'time') dispatch(setIsEditingTime(false));
    if (except !== 'month') dispatch(setShowMonthList(false));
    if (except !== 'year') dispatch(setShowYearList(false));
    if (except !== 'room') dispatch(setShowRoomDropdown(false));
    if (except !== 'users') dispatch(setShowUserList(false));
    if (except !== 'duration') setShowDurationDropdown(false);
    if (except !== 'reminder') setShowReminderDropdown(false);
};
    const handleCreateBooking = async (
        title,
        description,
        date,
        time,
        duration,
        selectedRoomUpdate,
        reminder,
        invites,

    ) => {
        try {
            const users = await dispatch(getAllUsers()).unwrap();
            const owner = users.find((user) => user.email === email);
            if (!owner) {
                console.error("Utilisateur non trouvé !");
                throw new Error("Utilisateur non trouvé !");
            }
            const [hours, minutes] = time.split(":").map(Number);
            const combinedDate = new Date(date);
            combinedDate.setHours(hours, minutes, 0, 0);

            const bookingData = {
                title,
                description,
                date: combinedDate.toISOString(),
                time,
                duration: parseInt(duration),
                room_id: selectedRoomUpdate.room_id,
                reminder_duration: parseInt(reminder),
                participants: (Array.isArray(invites) ? invites : []).map(
                    (email) => ({ email }),
                ),
                owner_email: email,
                map_id: mapConfig.mapId,
                ...recurrenceConfig,
                recurrence_end_date: recurrenceConfig?.recurrence_end_date || null,
                source: "event",
            };

            const response = await dispatch(createBooking({ body: { bookingData } })).unwrap();
            if (response && response.message) {
                dispatch(NEW_RESERVATION({ room_id: selectedRoomUpdate.room_id, isReserved: true, tenantId, refreshAll: true, }));
                dispatch(setAnchorPosition(null));
                dispatch(setOpenModal(null));

            }
        } catch (error) {
            console.error("Erreur API dans handleCreateBooking :", error);

            const src =
                error?.payload ??
                error?.response?.data ??
                error?.data ??
                error;

            let errorMessage = "Une erreur s'est produite lors de la réservation.";

            if (typeof src === "string") {
                errorMessage = src;
            } else if (Array.isArray(src?.errors) && src.errors.length > 0) {
                errorMessage = src.errors[0];
            } else if (typeof src?.message === "string" && src.message.trim() !== "") {
                errorMessage = src.message;
            }
            throw new Error(errorMessage);
        }

    };
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            setError();
            return;
        }
        setError();
        dispatch(setOpen(false));
    };

    useEffect(() => {
        console.log(selectedRoomUpdate);
    }, [selectedRoomUpdate])
    const handleUpdateBooking = async (
        bookingId,
        title,
        description,
        date,
        time,
        duration,
        selectedRoomUpdate,
        reminder,
        invites,
        onSuccess,
    ) => {
        if (!tenantId) return console.error("Erreur : tenantId manquant.");

        try {
            const startDateTime = new Date(date);
            const [hour, minute] = time.split(":").map(Number);
            startDateTime.setHours(hour, minute, 0, 0);
            if (!selectedRoomUpdate || !selectedRoomUpdate.room_id) {
                console.error("selectedRoomUpdate est null :", selectedRoomUpdate);
                setError("Veuillez sélectionner une salle avant de sauvegarder.");
                return;
            }
            const roomId = selectedRoomUpdate.room_id;
            const updatedData = {
                title,
                description,
                date: startDateTime,
                duration: Number(duration),
                room_id: selectedRoomUpdate.room_id,
                reminder_duration: Number(reminder),
                participants: invites,
                ownerEmail: email,
                map_id: mapConfig.mapId
            };

            if (!initialReservation.parent_booking_id) {
                Object.assign(updatedData, recurrenceConfig || {});
            }

            const res = await dispatch(
                updateBooking({ params: [{ bookingId }], body: { updatedData } })
            ).unwrap();
            dispatch(UPDATE_RESERVATION({
                new_room_id: roomId || selectedRoom?.room_id,
                old_room_id: selectedRoom?.room_id,
                isReserved: true,
                tenantId
            }));
            dispatch(setAnchorPosition(null));
            dispatch(setOpenModal(null));

        } catch (error) {
            console.error("Erreur lors de la mise à jour :", error);

            const src =
                error?.payload ??
                error?.response?.data ??
                error?.data ??
                error;

            setError(src?.message || "Erreur lors de la mise à jour de la réservation.");
        }
    };

    const handleBlur = () => {
        if (!isDropdownHovered) {
            dispatch(setIsEditingTime(false));
        }
    };

    const handleTimeSelect = (option) => {
        dispatch(setTime(option));
        dispatch(setIsEditingTime(false));
        setTimeout(() => {
            timeInputRef.current.blur();
        }, 100);
    };
    const handleDeleteBooking = async (id) => {
        try {
            const response = await dispatch(deleteBooking({ params: [{ bookingId: id }] }));
            if (response && response.payload.message) {
                dispatch(DELETE_RESERVATION({ bookingId: id }));
                dispatch(setAnchorPosition(null));
                dispatch(setOpenModal(null));

            }
        } catch (error) {
            setError("Erreur lors de la suppression de la réservation.");
        }
    };
    const generateTimeOptions = () => {
        const times = [];
        for (let hour = 0; hour < 24; hour++) {
            for (let minute of [0, 30]) {
                const formattedHour = String(hour).padStart(2, "0");
                const formattedMinute = String(minute).padStart(2, "0");
                times.push(`${formattedHour}:${formattedMinute}`);
            }
        }
        return times;
    };
    const handleInviteInputChange = (event) => {
        try {
            const inputValue = event.target.value;
            dispatch(setInviteInput(inputValue));

            if (inputValue.trim() === "") {
                dispatch(setFilteredUsers(
                    nonGuestUsers.filter(
                        (user) => user.email !== email && !invites.includes(user.email),
                    ),
                ));
                return;
            }

            const filtered = nonGuestUsers.filter(
                (user) =>
                    user.email.toLowerCase().includes(inputValue.toLowerCase()) &&
                    user.email !== email &&
                    !invites.includes(user.email),
            );
            dispatch(setFilteredUsers(filtered));
            dispatch(setShowUserList(true));
        } catch (error) {
            console.error(error);
        }
    };
    const handleRemoveInvite = (userEmail) => {
        try {
            dispatch(setInvites(invites.filter((invite) => invite !== userEmail)));
            const user = nonGuestUsers.find((user) => user.email === userEmail);
            if (user) {
                dispatch(setFilteredUsers([...filteredUsers, user]));
            }
        } catch (error) {
            console.error(error);
        }
    };
    const [isSubmitting, setIsSubmitting] = useState(false);
    const handleSubmitClick = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            if (inviteInput.trim() !== "") {
                handleAddInvite(inviteInput.trim());
            }

            await handleSubmit();
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSubmit = async () => {
        try {
            const now = new Date();
            const selectedDateTime = new Date(date);
            const [selectedHour, selectedMinute] = time.split(":").map(Number);
            selectedDateTime.setHours(selectedHour, selectedMinute, 0, 0);
            const nowWithMargin = new Date(now.getTime() - 30 * 1000);
            if (selectedDateTime < nowWithMargin) {
                setError(t("CANNOT_BOOK_IN_PAST"));
                return;
            }
            if (!title.trim()) {
                setError(t("TITLE_IS_REQUIRED"));
                return;
            }
            if (!date || isNaN(selectedDateTime.getTime())) {
                setError(t("DATE_IS_REQUIRED"));
                return;
            }
            if (!time || !/^\d{2}:\d{2}$/.test(time)) {
                setError(t("TIME_IS_INVALID"));
                return;
            }
            if (!duration || isNaN(Number(duration))) {
                setError(t("DURATION_IS_INVALID"));
                return;
            }
            if (!selectedRoomUpdate) {
                setError(t("ROOM_IS_REQUIRED"));
                return;
            }
            if (selectedDateTime < now) {
                setError(t("CANNOT_BOOK_IN_PAST"));
                return;
            }
            const formattedParticipants = invites.map(invite => {
                if (typeof invite === "string") {
                    return {
                        email: invite,
                        role: "guest",
                        status: "pending"
                    };
                } else if (invite.email && typeof invite.email === "string") {
                    return {
                        email: invite.email,
                        role: "guest",
                        status: "pending"
                    };
                } else {
                    console.error("[ERROR] Format inconnu pour invite :", invite);
                    return {
                        email: "",
                        role: "guest",
                        status: "pending"
                    };
                }
            });
            if (!tenantId) {
                setError("L'ID du tenant est manquant.");
                return;
            }
            if (initialReservation && updateRoom) {
                await handleUpdateBooking(
                    initialReservation.id,
                    title,
                    description,
                    selectedDateTime,
                    time,
                    duration,
                    selectedRoomUpdate,
                    reminder,
                    formattedParticipants,
                    () => onClose(),
                );
            } else {
                await handleCreateBooking(
                    title,
                    description,
                    selectedDateTime,
                    time,
                    duration,
                    selectedRoomUpdate,
                    reminder,
                    invites,
                    () => onClose(),
                );
            }
        } catch (error) {
            console.error("Erreur dans ReservationPopup :", error);
            if (Array.isArray(error)) {
                setError(error[0]);
            } else if (error.message) {
                setError(error.message);
            } else {
                setError(
                    t("ERROR_CREATING_RESERVATION")
                );
            }
        }
    };

    const handleAddInvite = (userEmail) => {
        try {
            const value = (userEmail || "").trim();
            if (!value) return;

            if (!selectedRoomUpdate) {
                setError("Veuillez sélectionner une salle avant d'ajouter des invités.");
                return;
            }

            const selectedRoomDetails = rooms.find(
                (room) => room.room_id === Number(selectedRoomUpdate.room_id)
            );

            if (!selectedRoomDetails) {
                setError("Salle sélectionnée non trouvée. Veuillez réessayer.");
                return;
            }

            // Regex pour extraire tous les emails valides d'un texte
            const emailRegex = /[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
            const foundEmails = value.match(emailRegex);

            if (!foundEmails || foundEmails.length === 0) {
                setError(t("EMAIL_IS_INVALID"));
                return;
            }

            const roomCapacity = selectedRoomDetails?.chair_count;
            // Filtrer les emails valides (uniques dans l'input)
            const uniqueFoundEmails = [...new Set(foundEmails)];

            let newInvitesToAdd = [];
            let capacityJustExceeded = false;
            let currentCount = 1 + invites.length; // Organisateur + invités actuels

            for (const emailToAdd of uniqueFoundEmails) {
                // Si déjà invité, on ignore
                if (invites.includes(emailToAdd)) continue;
                newInvitesToAdd.push(emailToAdd);
                currentCount++;

                if (!capacityJustExceeded && currentCount > roomCapacity) {
                    capacityJustExceeded = true;
                }
            }

            // Cas où tous les emails collés sont déjà dans la liste
            if (newInvitesToAdd.length === 0 && uniqueFoundEmails.length > 0) {
                dispatch(setInviteInput(""));
                dispatch(setShowUserList(false));
                return;
            }

            if (capacityJustExceeded) {
                setError(
                    `La capacité de la salle est dépassée. Capacité maximale : ${roomCapacity} personnes. Vous pouvez quand même ajouter des participants.`
                );
            }

            if (newInvitesToAdd.length > 0) {
                const nextInvites = [...invites, ...newInvitesToAdd];
                dispatch(setInvites(nextInvites));

                // Vérifier s'il y a des invités externes pour le message de succès
                const hasExternal = newInvitesToAdd.some(e => !nonGuestUsers.some(u => u.email === e));
                if (hasExternal) {
                    setSuccessMessage(t("EXTERNAL_GUEST_ADDED"));
                }

                // Mettre à jour la liste filtrée pour retirer ceux qu'on vient d'ajouter
                const nextFiltered = nonGuestUsers.filter(
                    (u) => u.email !== email && !nextInvites.includes(u.email)
                );
                dispatch(setFilteredUsers(nextFiltered));
            }

            dispatch(setInviteInput(""));
            dispatch(setShowUserList(false));

        } catch (error) {
            console.error(error);
        }
    };

    const handleInvitePaste = (e) => {
        const pasted = e.clipboardData?.getData("text") || "";
        const text = pasted.trim();

        const hasEmail = /[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/.test(text);
        if (!hasEmail) return;

        e.preventDefault();
        handleAddInvite(text);
    };


    useEffect(() => {
        if (successMessage) {
            const timer = setTimeout(() => {
                setSuccessMessage(null);
            }, 4000);
            return () => clearTimeout(timer);
        }
    }, [successMessage]);

    useEffect(() => {
        const initializeComponent = async () => {
            try {
                document.body.classList.add("modal-open");
                console.log("initialReservation", selectedRoomUpdate, initialReservation);
                if (initialReservation && updateRoom) {
                    const isChild = !!initialReservation.parent_booking_id;
                    if (isChild) {
                        setRecurrenceType("none");
                        setRecurrenceConfig(null);
                        setRecurrenceSummary("");
                    }
                    dispatch(setTitle(initialReservation.title || ""));
                    dispatch(setDescription(initialReservation.description || ""));
                    setDate(new Date(initialReservation.date));
                    const hours = new Date(initialReservation.date)
                        .getHours()
                        .toString()
                        .padStart(2, "0");
                    const minutes = new Date(initialReservation.date)
                        .getMinutes()
                        .toString()
                        .padStart(2, "0");
                    dispatch(setTime(`${hours}:${minutes}`));
                    dispatch(setDuration(initialReservation.duration?.toString() || "30"));
                    dispatch(setReminder(
                        initialReservation.reminder_duration !== undefined
                            ? String(initialReservation.reminder_duration)
                            : "10",
                    ));
                    //dispatch(setSelectedRoom(initialReservation.room?.id || ""));
                    dispatch(setInvites(
                        initialReservation.participants
                            ?.filter((p) => p.role === "guest")
                            .map((p) => p.email) || [],
                    ));
                    if (initialReservation.recurrence_unit && initialReservation.recurrence_unit !== "none") {
                        const unit = initialReservation.recurrence_unit;
                        const isCustom =
                            (unit === "week" && Array.isArray(initialReservation.recurrence_days) && initialReservation.recurrence_days.length > 1) ||
                            (initialReservation.recurrence_end_type && initialReservation.recurrence_end_type !== "never") ||
                            (initialReservation.recurrence_frequency && initialReservation.recurrence_frequency > 1) ||
                            (unit === "month" && initialReservation.recurrence_month_option);
                        if (isCustom) setRecurrenceType("custom");
                        else if (unit === "day") setRecurrenceType("daily");
                        else if (unit === "week") setRecurrenceType("weekly");
                        else if (unit === "year") setRecurrenceType("yearly");
                        else setRecurrenceType("none");
                        const recurrenceData = {
                            recurrence_unit: unit,
                            recurrence_frequency: initialReservation.recurrence_frequency || 1,
                            recurrence_days: initialReservation.recurrence_days || [],
                            recurrence_end_type: initialReservation.recurrence_end_type || "never",
                            recurrence_end_date: initialReservation.recurrence_end_date || null,
                            recurrence_occurrences: initialReservation.recurrence_occurrences || null,
                            recurrence_month_option: initialReservation.recurrence_month_option || null,
                        };
                        setRecurrenceConfig(recurrenceData);
                        setRecurrenceSummary(formatRecurrenceSummary(recurrenceData));
                    } else {
                        setRecurrenceType("none");
                        setRecurrenceConfig(null);
                        setRecurrenceSummary("");
                    }
                }
                else {
                    dispatch(setInit());
                    const today = new Date();
                    setDate(today);

                    let minutes = today.getMinutes();
                    let roundedMinutes = Math.ceil(minutes / 30) * 30;

                    if (roundedMinutes === 60) {
                        today.setHours(today.getHours() + 1);
                        roundedMinutes = 0;
                    }

                    dispatch(setTime(
                        `${String(today.getHours()).padStart(2, "0")}:${String(roundedMinutes).padStart(2, "0")}`,
                    ));

                }
            } catch (error) {
                console.error("Erreur pendant l'initialisation des champs :", error);
            }
            let effectiveMapId = mapConfig.mapId;

            if (initialReservation && updateRoom) {
                const mapIdFromReservation =
                    initialReservation?.room_tenant?.room?.map_id ||
                    initialReservation?.room?.map_id ||
                    initialReservation?.map_id;

                if (mapIdFromReservation) {
                    effectiveMapId = mapIdFromReservation;
                }
            }

            if (!effectiveMapId) {
                console.warn("Aucun map_id disponible pour charger les données (users/rooms)");
                dispatch(setRooms([]));
                dispatch(setNonGuestUsers([]));
                dispatch(setFilteredUsers([]));
                return;
            }

            try {
                const [usersResp, roomsResp] = await Promise.all([
                    dispatch(
                        fetchNonGuestUsersByMap({ params: [{ mapId: effectiveMapId }] })
                    ).unwrap(),
                    dispatch(
                        fetchRoomsByMapId({ params: [{ mapId: effectiveMapId }] })
                    ).unwrap(),
                ]);

                const users = Array.isArray(usersResp) ? usersResp : [];
                const candidateUsers = users.filter(u => u.email !== email);

                dispatch(setNonGuestUsers(candidateUsers));
                dispatch(setFilteredUsers(candidateUsers));

                const rawRooms = Array.isArray(roomsResp)
                    ? roomsResp
                    : (roomsResp?.rooms ?? []);

                const normalizedRooms = rawRooms
                    .map(it => ({
                        room_id: Number(it.room_id ?? it.id ?? it.room?.id),
                        label: String(it.label ?? it.room?.name ?? "Room"),
                        chair_count: Number(it?.chair_count ?? it.room?.chair_count ?? 0),
                    }))
                    .filter(r => Number.isFinite(r.room_id))
                    .sort((a, b) => String(a.label).localeCompare(String(b.label)));

                dispatch(setRooms(normalizedRooms));

                if (initialReservation && updateRoom) {
                    const targetRoomId =
                        initialReservation?.room_tenant?.room_id ||
                        initialReservation?.room_tenant?.room?.id ||
                        initialReservation?.room_id; const match = normalizedRooms.find(
                            r => Number(r.room_id) === Number(targetRoomId)
                        );
                    dispatch(setSelectedRoomupdate(match || normalizedRooms[0] || null));
                } else if (!selectedRoomUpdate && normalizedRooms[0]) {
                    dispatch(setSelectedRoomupdate(normalizedRooms[0]));
                }

            } catch (error) {
                console.error("Erreur d'initialisation AddEvent :", error);
                dispatch(setRooms([]));
                dispatch(setNonGuestUsers([]));
                dispatch(setFilteredUsers([]));
            }

        };
        if (!initRef.current) {
            initRef.current = true;
            initializeComponent();
        }
        return () => {
            document.body.classList.remove("modal-open");
        };
    }, [])
    const formatRecurrenceSummary = (data, date, time, duration, includeIntro = true) => {
        if (!data || !data.recurrence_unit) return "";

        const {
            recurrence_frequency = 1,
            recurrence_unit,
            recurrence_days = [],
            recurrence_end_type = "never",
            recurrence_occurrences,
            recurrence_month_option,
        } = data;

        const lang = preferredLanguage === "fr" ? "fr" : "en";
        const dayNames = {
            fr: {
                MO: "lun", MON: "lun",
                TU: "mar", TUE: "mar",
                WE: "mer", WED: "mer",
                TH: "jeu", THU: "jeu",
                FR: "ven", FRI: "ven",
                SA: "sam", SAT: "sam",
                SU: "dim", SUN: "dim",
            },
            en: {
                MO: "Mon", MON: "Mon",
                TU: "Tue", TUE: "Tue",
                WE: "Wed", WED: "Wed",
                TH: "Thu", THU: "Thu",
                FR: "Fri", FRI: "Fri",
                SA: "Sat", SAT: "Sat",
                SU: "Sun", SUN: "Sun",
            },
        };

        const jours = recurrence_days.map((c) => {
            const key = c.trim().toUpperCase();
            return dayNames[lang][key] || key;
        });
        const daysText = jours.length > 0 ? jours.join(lang === "fr" ? " et " : " and ") : "";

        const freqText =
            recurrence_frequency > 1
                ? lang === "fr"
                    ? `toutes les ${recurrence_frequency}`
                    : `every ${recurrence_frequency}`
                : lang === "fr"
                    ? "chaque"
                    : "every";
        const unitText =
            recurrence_unit === "week"
                ? lang === "fr"
                    ? "semaine"
                    : "week"
                : recurrence_unit === "day"
                    ? lang === "fr"
                        ? "jour"
                        : "day"
                    : recurrence_unit === "month"
                        ? lang === "fr"
                            ? "mois"
                            : "month"
                        : lang === "fr"
                            ? "an"
                            : "year";

        let summary = "";
        switch (recurrence_unit) {
            case "day":
                summary =
                    lang === "fr"
                        ? `Répété ${freqText} jour${recurrence_frequency > 1 ? "s" : ""}`
                        : `Repeats ${freqText} day${recurrence_frequency > 1 ? "s" : ""}`;
                break;
            case "week":
                summary =
                    lang === "fr"
                        ? `Répété ${freqText} semaine${recurrence_frequency > 1 ? "s" : ""}`
                        : `Repeats ${freqText} week${recurrence_frequency > 1 ? "s" : ""}`;
                if (daysText) summary += lang === "fr" ? ` (${daysText})` : ` (${daysText})`;
                break;
            case "month":
                summary =
                    lang === "fr"
                        ? `Répété ${freqText} mois`
                        : `Repeats ${freqText} month`;
                if (recurrence_month_option === "dayNumber")
                    summary += lang === "fr"
                        ? " (chaque même date)"
                        : " (same date each month)";
                else if (recurrence_month_option === "lastWeekday")
                    summary += lang === "fr"
                        ? " (le dernier jour ouvré du mois)"
                        : " (the last weekday of the month)";
                break;
            case "year":
                summary =
                    lang === "fr"
                        ? `Répété ${freqText} an${recurrence_frequency > 1 ? "s" : ""}`
                        : `Repeats ${freqText} year${recurrence_frequency > 1 ? "s" : ""}`;
                break;
        }
        if (recurrence_end_type === "after")
            summary += lang === "fr"
                ? ` (${recurrence_occurrences || 1} occurrences)`
                : ` (${recurrence_occurrences || 1} occurrences)`;
        else if (recurrence_end_type === "onDate") {
            if (data.recurrence_end_date) {
                const endDate = new Date(data.recurrence_end_date);
                const formattedEndDate = endDate.toLocaleDateString(
                    lang === "fr" ? "fr-FR" : "en-US",
                    {
                        weekday: "long",
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                    });
                summary += lang === "fr"
                    ? ` (jusqu’au ${formattedEndDate})`
                    : ` (until ${formattedEndDate})`;
            } else {
                summary += lang === "fr"
                    ? ` (jusqu’à la date définie)`
                    : ` (until defined date)`;
            }
        } else if (recurrence_end_type === "never")
            summary += lang === "fr"
                ? ` (sans date de fin)`
                : ` (no end date)`;
        if (includeIntro && date && time && duration) {
            const startDate = new Date(date);
            const [h, m] = time.split(":").map(Number);
            startDate.setHours(h, m, 0, 0);
            const endDate = new Date(startDate.getTime() + duration * 60 * 1000);
            const endHour = String(endDate.getHours()).padStart(2, "0");
            const endMin = String(endDate.getMinutes()).padStart(2, "0");

            const formattedStart = startDate.toLocaleDateString(
                lang === "fr" ? "fr-FR" : "en-US",
                {
                    weekday: "long",
                    day: "numeric",
                    month: "long",
                });

            summary =
                lang === "fr"
                    ? `Cet évènement débutera à partir du ${formattedStart} entre ${time} et ${endHour}:${endMin}, ${summary}.`
                    : `This event will start on ${formattedStart} between ${time} and ${endHour}:${endMin}, ${summary}.`;
        } else {
            summary += ".";
        }

        return summary;
    };

    return (
        <>
            <div className="modal-body"
                onClick={() => {
                    if (showUserList) dispatch(setShowUserList(false));
        if (isEditingTime) dispatch(setIsEditingTime(false));
                }} 
                
                onClickCapture={(e) => {
                    if (!(e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA" || e.target.isContentEditable)) {
                        e.preventDefault();
                    }
                }}
            >
                <div className="form-group">
                    <label>{t("event_title")} <span className="required-field">*</span></label>
                    <div className="input-with-button">
                        <input
                            className="event-input"
                            type="text"
                            placeholder={t("enter_event_name")}
                            value={title}
                            onChange={(e) => dispatch(setTitle(e.target.value))}
                        />
                        <button
                            className="description-btn"
                            onClick={() => dispatch(setShowDescription(!showDescription))}
                        >
                            {showDescription
                                ? t("hide")
                                : t("add_description")}
                        </button>
                    </div>
                </div>

                {showDescription && (
                    <div className="form-group">
                        <label>{t("description")}</label>
                        <textarea
                            placeholder={t("enter_description")}
                            value={description}
                            onChange={(e) => dispatch(setDescription(e.target.value))}
                            className="description-input"
                        />
                    </div>
                )}

                <div className="form-row inline">
                    <div className="form-group ev-date">
                        <label>{t("date")} <span className="required-field">*</span></label>
                        <div className="input-icon" style={{ position: 'relative', display: 'inline-block' }}>
                            <DatePicker
                                selected={date}
                                onChange={(newDate) => {
                                    setDate(newDate);
                                    dispatch(setOpen(false));
                                }}
                                minDate={new Date()}
                                dateFormat="eeee d MMMM "
                                className="date-display-input"
                                popperPlacement="bottom-start"
                                open={open}
                                onClickOutside={() => {
                                    dispatch(setOpen(false));
                                    dispatch(setShowMonthList(false));
                                    dispatch(setShowYearList(false));
                                }}
                                locale={getLocaleObject(preferredLanguage)}
                                renderCustomHeader={({
                                    date,
                                    changeYear,
                                    changeMonth,
                                    decreaseMonth,
                                    increaseMonth,
                                    prevMonthButtonDisabled,
                                    nextMonthButtonDisabled
                                }) => (
                                    <div className="custom-header">
                                        <button
                                            onClick={decreaseMonth}
                                            disabled={prevMonthButtonDisabled}
                                            className="nav-btn"
                                        >
                                            <span className="material-symbols-outlined">chevron_left</span>
                                        </button>

                                        {/* Mois personnalisé */}
                                        <div className="custom-dropdown">
                                            <div
                                                className="dropdown-trigger"
                                                onClick={() => {
                                                    dispatch(setShowMonthList(!showMonthList));
                                                    dispatch(setShowYearList(false));
                                                    
                                                }}
                                            >
                                                {MONTHS[date.getMonth()]}
                                                <span className="material-symbols-outlined">keyboard_arrow_down</span>
                                            </div>
                                            {showMonthList && (
                                                <ul className="dropdown-list">
                                                    {MONTHS.map((month, index) => (
                                                        <li
                                                            key={index}
                                                            className={index === date.getMonth() ? "active" : ""}
                                                            onClick={() => {
                                                                closeAllDropdowns('month');
                                                                changeMonth(index);
                                                                dispatch(setShowMonthList(false));
                                                            }}
                                                        >
                                                            {month}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>

                                        {/* Année personnalisée */}
                                        <div className="custom-dropdown">
                                            <div
                                                className="dropdown-trigger"
                                                onClick={() => {
                                                    dispatch(setShowYearList(!showYearList));
                                                    dispatch(setShowMonthList(false));
                                                }}
                                            >
                                                {date.getFullYear()}
                                                <span className="material-symbols-outlined">keyboard_arrow_down</span>
                                            </div>
                                            {showYearList && (
                                                <ul className="dropdown-list">
                                                    {years.map((year) => (
                                                        <li
                                                            key={year}
                                                            className={year === date.getFullYear() ? "active" : ""}
                                                            onClick={() => {
                                                                closeAllDropdowns('year');
                                                                changeYear(year);
                                                                dispatch(setShowYearList(false));
                                                            }}
                                                        >
                                                            {year}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>

                                        <button
                                            onClick={increaseMonth}
                                            disabled={nextMonthButtonDisabled}
                                            className="nav-btn"
                                        >
                                            <span className="material-symbols-outlined">chevron_right</span>
                                        </button>
                                    </div>
                                )}
                            />

                            <CalendarIcon
                                size={18}
                                className="clickable-icon1"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    dispatch(setOpen(!open));
                                    closeAllDropdowns('date');
                                }}
                                style={{
                                    position: "absolute",
                                    top: "50%",
                                    right: "0.625rem",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer"
                                }}
                            />
                        </div>

                    </div>

                    <div className="form-group ev-date">
                            <label>{t("time")} <span className="required-field">*</span></label>

                            <div
                                className="input-icon time-container"
                                style={{ position: "relative" }}
                            >
                                <input
                                    type="text"
                                    value={time}
                                    onChange={(e) => dispatch(setTime(e.target.value))}
                                    onFocus={() => dispatch(setIsEditingTime(true))}
                                    onBlur={(e) => {
                                        const val = e.target.value.trim();
                                        const valid = /^([01]\d|2[0-3]):([0-5]\d)$/.test(val);
                                        if (!valid) {
                                            dispatch(setTime(""));
                                            setError(t("TIME_IS_INVALID"));
                                        }
                                        handleBlur();
                                    }}
                                    placeholder="HH:MM"
                                    ref={timeInputRef}
                                    className="time-input"
                                />

                                <Clock
                                    size={18}
                                    className="clickable-icon"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        closeAllDropdowns('time');
                                        dispatch(setIsEditingTime(!isEditingTime));
                                    }}
                                />

                                {isEditingTime && (
                                    <div
                                        className="time-dropdown-container"
                                      ref={(el) => {
                                            dropdownRef.current = el;
                                            timeOptionsRef.current = el;
                                        }}
                                        onMouseEnter={() => setIsDropdownHovered(true)}
                                        onMouseLeave={() => setIsDropdownHovered(false)}
                                    >
                                        {generateTimeOptions().map((option) => (
                                            <div
                                                key={option}
                                                ref={option === time ? timeOptionsRef : null}
                                                className={`time-option ${option === time ? "selected-time" : ""}`}
                                                tabIndex="0"
                                                onMouseDown={(e) => e.preventDefault()}
                                                onClick={() => {
                                                    handleTimeSelect(option);
                                                    closeAllDropdowns('time');
                                                }}
                                            >
                                                {option}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        
</div>

                    <div className="form-group ev-date">
                            <label>{t("duration")} <span className="required-field">*</span></label>

                            <div
                                className="input-icon duration-container"
                                style={{ display: "flex", alignItems: "center", position: "relative" }}
                            >
                                <CustomDropdown
                                    options={[
                                        { value: "15", label: `15 ${t("minutes")}` },
                                        { value: "30", label: `30 ${t("minutes")}` },
                                        { value: "45", label: `45 ${t("minutes")}` },
                                        { value: "60", label: `1 ${t("hour")}` },
                                        { value: "75", label: `1h 15 ${t("minutes")}` },
                                        { value: "90", label: `1h 30 ${t("minutes")}` },
                                        { value: "105", label: `1h 45 ${t("minutes")}` },
                                        { value: "120", label: `2 ${t("hours")}` },
                                    ]}
                                    value={duration}
                                    onChange={(val) => dispatch(setDuration(val))}
                                    placeholder={t("select_duration")}
                                    minWidth="7.5rem"
                                    showIcon={false}
                                    isOpen={showDurationDropdown}
                                    onOpenChange={(next) => {
                                        if (next) closeAllDropdowns('duration');
                                        setShowDurationDropdown(next);
                                    }}
                                />

                                <Hourglass
                                    size={18}
                                    className="duration-icon"
                                    style={{
                                        position: "absolute",
                                        right: "0.625rem",
                                        color: "#555",
                                        pointerEvents: "none",
                                    }}
                                />
                            </div>
                        </div>


                </div>
                <div className="form-group">
                    <label>{t("recurrence")}</label>
                    <div style={{
    display: "flex",
    padding: "var(--spacing-md, 8px) var(--spacing-lg, 12px)",
    alignItems: "center",
    gap: "var(--spacing-md, 8px)",
    alignSelf: "stretch",
    borderRadius: "var(--radius-md, 8px)",
    border: "1px solid var(--Colors-Border-border-primary, #D5D7DA)",
    background: "#FFF",
    boxShadow: "0 1px 3px 0 var(--Colors-Effects-Shadows-shadow-sm_01, rgba(10, 13, 18, 0.10)), 0 1px 2px -1px var(--Colors-Effects-Shadows-shadow-sm_02, rgba(10, 13, 18, 0.10))",
    width: "18.125rem"
  }}>
                    <CustomDropdown
                        options={[
                            { value: "none", label: t("none") },
                            { value: "daily", label: t("daily") },
                            { value: "weekly", label: t("weekly") },
                            {
                                value: "yearly",
                                label: t("yearly_on", {
                                    date: `${date.getDate()} ${date.toLocaleDateString(
                                        preferredLanguage === "fr" ? "fr-FR" : "en-US",
                                        { month: "long" }
                                    )}`,
                                }),
                            },
                            { value: "custom", label: t("customize") },
                        ]}
                        value={recurrenceType}
                        onChange={(value) => {
                            handleRecurrenceChange(value);
                        }}
                        width="18.125rem"
                        
                    />
                    </div>
                </div>
                {recurrenceSummary && (
                    <div
                     className ="dropdown-container"
                    >
                        {recurrenceSummary}
                    </div>
                )}

                <div className="form-group">
                    <label>{t("add_guests")} <span className="required-field">*</span></label>
                    <div className="input-invitation">
                        <div className="invites-container">
                            {invites.map((invite, index) => (
                                <div key={index} className="invite-tag">
                                    {invite}
                                    <CloseIcon
                                        className="remove-invite"
                                        fontSize="small"
                                        onClick={() =>
                                            handleRemoveInvite(invite)
                                        }
                                    />
                                </div>
                            ))}
                            <input
                            
                            
                                type="text"
                                placeholder={t("search_user_or_enter_email")}
                                value={inviteInput}
                                onChange={handleInviteInputChange}
                                onPaste={handleInvitePaste}
                                onClick={() => {
                                    dispatch(setShowUserList(!showUserList))
                                    closeAllDropdowns('users');
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault();
                                        handleAddInvite(inviteInput.trim());
                                    }
                                }}
                                onBlur={() => {
                                    if (pickingFromList) return;
                                    const v = inviteInput.trim();
                                    if (v) handleAddInvite(v, { silentInvalid: true });
                                }}
                                style={{ border: "1px solid #D5D7DA" }}

                            />

                            <button
                                className="add-invite-btn"
                                onClick={() =>
                                    handleAddInvite(inviteInput.trim())
                                }
                            >
                                {t("add")}
                            </button>
                        </div>
                    </div>

                    {showUserList && (
                        <div className="user-list-container">
                            <ul className="user-list">
                                {filteredUsers.length > 0 ? (
                                    filteredUsers.map((user) => (
                                        <li
                                            key={user.email}
                                            onMouseDown={() => setPickingFromList(true)}
                                            onClick={() => {
                                                handleAddInvite(user.email);
                                                setPickingFromList(false);
                                            }}
                                            className="user-item"
                                        >
                                            <span className="user-email">{user.email}</span>
                                            <button className="add-user-btn">+</button>
                                        </li>

                                    ))
                                ) : (
                                    <li className="no-users">
                                        {t("NO_MATCHING_USER_FOUND")}
                                    </li>
                                )}
                            </ul>
                        </div>
                    )}
                </div>

                <div className="form-group">
                    <label>{t("room_peoplmap")} <span className="required-field">*</span></label>
                    <div
                        className="input-icon salle-dropdown"
                        style={{ position: "relative" }}
                        onClick={() => {
                            const willOpen = !showRoomDropdown;
                            closeAllDropdowns('room');
                            dispatch(setShowRoomDropdown(willOpen));
                        }}                    >
                        <div className="dropdown-selected">
                            <span
                                className="selected-room-text"
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                }}
                            >
                                <span>
                                    {selectedRoomUpdate?.label || "Choisir une salle"}
                                </span>
                                {selectedRoomUpdate && (
                                    <div  className='room-capacity-container'>

                                   
                                    <span
                                        className="room-capacity"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "0.25rem",
                                        }}
                                    >
                                        {selectedRoomUpdate?.chair_count}
                                        
                                    </span>
                                    <span class="material-symbols-outlined group-icon">
                                            groups
                                        </span>
                                     </div>
                                )}
                            </span>

                           
                        </div>
                        {showRoomDropdown && (
                            <div className="dropdown-options">
                                {rooms.map((room) => (
                                    <div
                                        key={room.room_id}
                                        className={`dropdown-option ${String(selectedRoomUpdate) === String(room.room_id) ? "selected" : ""}`}
                                        onClick={() => {
                                            dispatch(setSelectedRoomupdate(room));
                                            dispatch(setShowRoomDropdown(false));
                                        }}
                                    >
                                        <span>{room.label}</span>
                                        <span className="room-capacity">
                                            {room?.chair_count}
                                            <Users
                                                size={16}
                                                className="capacity-icon"
                                            />
                                        </span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                <div className="form-group">
                    <label>{t("reminder")}</label>

                   <div style={{
    display: "flex",
    padding: "var(--spacing-md, 8px) var(--spacing-lg, 12px)",
    alignItems: "center",
    gap: "var(--spacing-md, 8px)",
    alignSelf: "stretch",
    borderRadius: "var(--radius-md, 8px)",
    border: "1px solid var(--Colors-Border-border-primary, #D5D7DA)",
    background: "#FFF",
    boxShadow: "0 1px 3px 0 var(--Colors-Effects-Shadows-shadow-sm_01, rgba(10, 13, 18, 0.10)), 0 1px 2px -1px var(--Colors-Effects-Shadows-shadow-sm_02, rgba(10, 13, 18, 0.10))",
    width: "18.125rem"
  }}>
                        <CustomDropdown
                            options={[5, 10, 15, 20, 25, 30].map((min) => ({
                                value: String(min),
                                label: `${min} ${t("minutes")}`,
                            }))}
                            value={String(reminder)}
                            onChange={(val) => dispatch(setReminder(val))}
                            placeholder={t("select_reminder")}
                            width="100%"
                            minWidth="8.75rem"
                            showIcon={false}
                            isOpen={showReminderDropdown}
                            onOpenChange={(next) => {
                                if (next) closeAllDropdowns('reminder');
                                setShowReminderDropdown(next);
                            }}
                        />

                        <Bell
                            size={18}
                            className="reminder-icon"
                            style={{
                                position: "relative",
                                right: "0.625rem",
                                color: "#555",
                                pointerEvents: "none",
                            }}
                        />
                    </div>
                </div>

                <div className="buttons">
                    {initialReservation && updateRoom && (
                        <div>
                            <button className="cancel-btn" onClick={() => dispatch(setConfirmDialogOpen(true))}>
                                <span class="material-symbols-outlined">
                                    delete
                                </span>
                                <span className="label-descktop">{t("delete")}</span>
                            </button>
                            {<ActionConfirmation
                                open={confirmDialogOpen}
                                title={
                                    initialReservation.parent_booking_id
                                        ? t("delete_single_occurrence")
                                        : t("delete_recurrence_series")
                                }
                                msg={
                                    initialReservation.parent_booking_id
                                        ? t("delete_single_occurrence_msg")
                                        : t("delete_recurrence_series_msg")
                                }
                                cancelText={t("cancel")}
                                confirmText={t("delete")}
                                variant="destructive" // 🔥 ici pour forcer l’icône delete rouge
                                onClose={() => {
                                    dispatch(setConfirmDialogOpen(false));
                                    onClose();
                                }
                                }
                                onConfirm={() => {
                                    handleDeleteBooking(initialReservation.id);
                                    dispatch(setConfirmDialogOpen(false));
                                    onClose();
                                }}
                            />
                            }
                        </div>
                    )}
                    {!initialReservation && !updateRoom &&
                        <button className="cancel" onClick={onClose}>
                            {t("cancel")}
                        </button>
                    }
                    <button className="create-btn" onClick={handleSubmitClick} disabled={isSubmitting}>
                        {initialReservation && updateRoom ? t("update_event") : t("create_event")}
                    </button>
                </div>
                {showCustomRecurrence && (
                    <CustomRecurrencePopup
                        baseDate={date}
                        onClose={() => {
                            setShowCustomRecurrence(false);
                        }}
                        onSave={(data) => {
                            setRecurrenceConfig(data);
                            setRecurrenceType("custom");
                            setShowCustomRecurrence(false);
                            const summary = formatRecurrenceSummary(data, date, time, duration, true);
                            setRecurrenceSummary(summary);
                        }}
                    />
                )}

            </div>
        </>
    );
}
